import { render } from "./fiscalData.vue?vue&type=template&id=4395c1a0&ts=true"
import script from "./fiscalData.vue?vue&type=script&lang=ts"
export * from "./fiscalData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__